var map = {
	"./assetx.js": [
		3040,
		40
	],
	"./automata.js": [
		9830,
		830
	],
	"./benchmatrix.js": [
		3289,
		289
	],
	"./bioportal.js": [
		6,
		6
	],
	"./blocksettle.js": [
		5908,
		908
	],
	"./branchfuture.js": [
		3999,
		999
	],
	"./fatcaplus.js": [
		4401,
		401
	],
	"./korepay.js": [
		2117,
		117
	],
	"./mxpay.js": [
		3947,
		947
	],
	"./mxpay/architecture/ArchitecturePage.js": [
		2728
	],
	"./mxpay/systac2/ProcessDetailPage.js": [
		2683
	],
	"./mxpay/systac2/SYSTAC2Page.js": [
		5020
	],
	"./mxpay/systac2/components/ProcessViewer.js": [
		6858
	],
	"./mxpay/systac2/services/ProcessService.js": [
		3772
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2997;
module.exports = webpackAsyncContext;